export default __webpack_public_path__ + "static/media/FileaDispute.93cf67f4.svg";